// Shared countdown module for every [data-promo-timer] element (header flash
// promo, deal-of-day, bogo-strip). Server renders a unix timestamp in
// data-ends-at; this just ticks the day/hr/min/sec cells every second.

function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
}

function tick(el) {
    const endsAt = parseInt(el.getAttribute('data-ends-at'), 10) * 1000;
    const now = Date.now();
    const diff = Math.max(0, endsAt - now);

    const days = Math.floor(diff / 86400000);
    const hrs = Math.floor((diff % 86400000) / 3600000);
    const min = Math.floor((diff % 3600000) / 60000);
    const sec = Math.floor((diff % 60000) / 1000);

    const daysEl = el.querySelector('[data-timer-days]');
    const hrsEl = el.querySelector('[data-timer-hrs]');
    const minEl = el.querySelector('[data-timer-min]');
    const secEl = el.querySelector('[data-timer-sec]');

    if (daysEl) {
        daysEl.parentElement.style.display = days > 0 ? 'flex' : 'none';
        daysEl.textContent = pad(days);
    }
    if (hrsEl) hrsEl.textContent = pad(hrs);
    if (minEl) minEl.textContent = pad(min);
    if (secEl) secEl.textContent = pad(sec);
}

function init() {
    const timers = document.querySelectorAll('[data-promo-timer]');
    if (!timers.length) return;
    timers.forEach((el) => tick(el));
    setInterval(() => timers.forEach((el) => tick(el)), 1000);
}

export default { init };
